export let productsData = {
	all: []
};
export let collections = {
	wrap: null,
	target: null,
	select: function( href ){
		history.pushState({}, '', href);
		collections.checkURL(href);
	},
	checkURL: function(){
		let path = location.pathname;
		let pathArry = path.split("/");
		let currentCat = pathArry[ pathArry.length - 2];
		//console.log(currentCat)
		//console.log(pathArry, pathArry[1])
		if( pathArry[1] === "collections" ){
			collections.changeCategory(currentCat);
			//console.log(pathArry, currentCat);
			activeNav();
			function activeNav(){
				let $navs = document.querySelectorAll(`[data-template="collection"] .c-nav_filter a`);
				$navs.forEach( ( $a ) => {
					//console.log($a.getAttribute("href"), path)
					if( $a.getAttribute("href") === path ){
						$a.classList.add("active");
					}else{
						if( $a.classList.contains("active") ){
							$a.classList.remove("active");
						}
					}
				});
			}
		}
	},
	changeCategory: function(currentCat){
		if( collections.wrap.classList.contains("disable") ){
			activeClass();
		}else{
			collections.wrap.classList.add("disable");
			collections.wrap.addEventListener("transitionend", function(){
				activeClass();
			},{
				"once": true
			});
		}
		function activeClass(){
			let activeCls = `active-${currentCat}`;
			collections.target.className = "";
			collections.target.classList.add(activeCls);
			setTimeout(function(){
				collections.wrap.classList.remove("disable");
			}, 100);
		}
		
	},
	addHTML: async function(){
		let path = location.pathname;
		let pathArry = path.split("/");
		if( pathArry[1] === "collections" ){
			collections.wrap 	= document.querySelector(`[data-template="collection"] .list_product`);
			collections.target 	= document.querySelector(`[data-template="collection"] .list_product ul`);
			let className = collections.target.className;
			//------------------------------------------------
			//プロダクトが一度読み込まれてHTMLがaddされていたらここでは何もしない
			//------------------------------------------------
			if( collections.target && className.length === 0){
				let HTML = "";
				if( productsData.all.length > 0 ){
					for(let i = 0; i < productsData.all.length; i++){
						let data = productsData.all[i];
						let collectionCls = "";
						data.collections.forEach( (c) => {
							if( c.handle != "frontpage" ){
								collectionCls += ` ${c.handle}`;
							}
						});
						console.log(data)
						HTML += `<li class="${collectionCls}">
									<a href="${data.url}" class="full-unstyled-link">
										<figure>
											<img srcset="${data.featured_image.url}&amp;width=165 165w,
											${data.featured_image.url}&amp;width=360 360w,
											${data.featured_image.url}&amp;width=533 533w,
											${data.featured_image.url}&amp;width=720 720w,
											${data.featured_image.url} 1080w" src="${data.featured_image.url}?v=1759875148&amp;width=533" sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="${data.handle}" width="${data.featured_image.width}" height="${data.featured_image.height}">
										</figure>
										<div class="info">
											<h3><span class="en">${data.product_code}</span></h3>
											<div class="c-price-wrap">
												<div class="js-price-slot price ">
													<div class="price__container">
														<div class="price__regular">
															<span class="price-item price-item--regular">¥${data.price_min.toLocaleString()}<span class="u-tax">(tax in)</span>〜</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</a>
								</li>`
					}
					collections.target.innerHTML = HTML;
					collections.checkURL();
				}else{
					setTimeout(function(){
						collections.addHTML();
					}, 100);
				}
			}
		}
	}
}